import React, { Component } from "react";

import { SalarytemplateValidation } from "../../SettingValidation";
import { postApi } from "../../../../utils/apiHelper";
import apiRoutes from "../../../../utils/apiRoutes";
import DateTimeService from "../../../../utils/dateTimeService";

import InputContainer from "./InputContainer";
import Label from "./Label";
import TextBox from "./TextBox";
import SelectDropdown from "./SelectDropdown";
import SalaryInput from "./SalaryInput";
import AddButton from "./AddButton";
import RemarkInput from "./RemarkInput";
import SubmitButton from "./SubmitButton";

const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class SalaryTemplateAddNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new DateTimeService().todayDate,
      basic_salary: "",
      career_level: null,
      career_sub_level: null,
      remark: "",
      salarySlips: [],
      validateErr: {},
      editId: null,
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.salarySlips !== this.state.salarySlips) {
      this.showTable(this.state.salarySlips);
    }
  }

  componentDidMount() {
    this.showTable(this.state.salarySlips);
  }

  handleInputChange = (e) => {
    const id = e.target.id;
    const val = e.target.value;
    if (id === "basic_salary" && val < 0) return;

    const setState = {};
    setState[id] = val;
    this.setState(setState);
  };

  handleSelectorChange = (key, val) => {
    const { sub_level_options, level_options } = this.props;
    const value =
      key === "career_level"
        ? level_options.find(
            (v) => Number(v.career_level_id) === Number(val.career_level_id)
          ).career_level_id
        : sub_level_options.find(
            (v) =>
              Number(v.career_sub_level_id) === Number(val.career_sub_level_id)
          ).career_sub_level_id;

    const setState = {};
    setState[key] = value;

    // To automatically pick the career sub level when career level changes
    if (
      key === "career_level" &&
      val.career_level_id !== this.state.career_level
    ) {
      setState["career_sub_level"] = sub_level_options.find(
        (v) => Number(v.career_level_id) === Number(val.career_level_id)
      ).career_sub_level_id;
    }

    this.setState(setState);
  };

  handleAdd = () => {
    const {
      date,
      basic_salary,
      career_level,
      career_sub_level,
      salarySlips,
      editId,
    } = this.state;
    const data = { date, basic_salary, career_level, career_sub_level };
    const validateErr = SalarytemplateValidation(data);
    this.setState({ validateErr });

    if (Object.keys(validateErr).length === 0) {
      var addData_ = [...salarySlips];
      if (editId) {
        const index = salarySlips.findIndex((v) => v.id === editId);
        const editData = {
          date,
          basic_salary,
          career_level,
          career_sub_level,
          salarySlips,
          id: editId,
        };
        addData_.splice(index, 1, editData);
      } else {
        addData_.push({
          career_level,
          career_sub_level,
          basic_salary,
          date,
          id: salarySlips.length + 1,
        });
      }
      this.setState({
        salarySlips: addData_,
        date: new DateTimeService().todayDate,
        basic_salary: "",
        career_level: null,
        career_sub_level: null,
        editId: null,
      });
    } else {
      this.props.showToast(0, "Please Add Full Information.");
    }
  };

  handleSave = async () => {
    const { salarySlips, remark } = this.state;
    const data = {
      salarySlips,
      remark,
    };

    try {
      const createdSalarySlips = await postApi(
        apiRoutes.salaryTemplate,
        data,
        false
      );
      const count = createdSalarySlips.data.length;
      const successMesg =
        count > 1
          ? `${count} new salary slips have been added successfully.`
          : `A new salary slip has been added successfully.`;
      this.props.showToast(200, successMesg);
    } catch (error) {
      this.props.showToast(400, "Something went wrong. Unable to save data.");
    }
  };

  showTable(data) {
    var table;
    var self = this;
    var list = [];
    var obj,
      one = [];
    const { level_options, sub_level_options } = this.props;

    for (let i = 0; i < data.length; i++) {
      obj = data[i];
      one = {
        no: i + 1,
        date: new DateTimeService(obj.date).formatDate,
        basic_salary: obj.basic_salary,
        career_level: level_options.find(
          (v) => Number(v.career_level_id) === Number(data[i].career_level)
        )
          ? level_options.find(
              (v) => Number(v.career_level_id) === Number(data[i].career_level)
            ).career_level
          : "",
        career_sub_level: sub_level_options.find(
          (v) =>
            Number(v.career_sub_level_id) === Number(data[i].career_sub_level)
        )
          ? sub_level_options.find(
              (v) =>
                Number(v.career_sub_level_id) ===
                Number(data[i].career_sub_level)
            ).career_sub_level
          : "",
        action:
          '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="Edit" ><span id="edit" class="hidden" >' +
          JSON.stringify(obj) +
          '</span>&nbsp;Edit</button><button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="Remove" ><span id="remove" class="hidden" >' +
          JSON.stringify(obj) +
          "</span>&nbsp;Remove</button>",
      };

      list.push(one);
    }

    if ($.fn.dataTable.isDataTable("#dataTables")) {
      table = $("#dataTables").dataTable({
        destroy: true,
        searching: false,
      });
      table.fnDestroy();
    }

    var column = [
      { title: "No", data: "no" },
      { title: "Date", data: "date" },
      { title: "Basic Salary", data: "basic_salary" },
      { title: "Career Level", data: "career_level" },
      { title: "Career Sub Level", data: "career_sub_level" },
      { title: "Action", data: "action" },
    ];

    table = $("#dataTables").DataTable({
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: true,
      dom: "Bfrtip",
      data: list,
      buttons: [],
      columns: column,
    });

    $("#dataTables").on("click", "#Edit", function (event) {
      event.preventDefault();
      var data = $(this).find("#edit").text();
      data = $.parseJSON(data);
      self.goToEdit(data);
    });

    $("#dataTables").on("click", "#Remove", function (event) {
      event.preventDefault();
      var data = $(this).find("#remove").text();
      data = $.parseJSON(data);
      self.goToRemove(data);
    });
  }

  goToEdit = (data) => {
    this.setState({
      editId: data.id,
      date: data.date,
      basic_salary: data.basic_salary,
      career_level: data.career_level,
      career_sub_level: data.career_sub_level,
    });
  };

  goToRemove = (data) => {
    let dataForRemove = this.state.salarySlips;
    let newData = dataForRemove.filter((v) => v.id !== data.id);
    this.setState({
      salarySlips: newData,
    });
  };

  render() {
    const {
      basic_salary,
      career_level,
      career_sub_level,
      remark,
      salarySlips,
    } = this.state;
    const { level_options, sub_level_options } = this.props;
    const selectedCareerLevel = level_options.find(
      (v) => Number(v.career_level_id) === Number(career_level)
    );
    const selectedCareerSubLevel = sub_level_options.find(
      (v) => Number(v.career_sub_level_id) === Number(career_sub_level)
    );
    const FilteredCareerSubLevel = career_level
      ? sub_level_options.filter(
          (v) => Number(v.career_level_id) === Number(career_level)
        )
      : sub_level_options;

    return (
      <div className="container">
        <div className="row">
          <form id="check_form">
            <div
              className="row"
              style={{
                marginTop: "20px",
              }}
            >
              <InputContainer>
                <Label htmlFor="date">Date</Label>
                <TextBox text={new DateTimeService().todayDate} />
              </InputContainer>

              <InputContainer>
                <Label htmlFor="career_level" isRequired>
                  Career Level
                </Label>
                <SelectDropdown
                  options={level_options}
                  onChange={this.handleSelectorChange.bind(
                    this,
                    "career_level"
                  )}
                  value={selectedCareerLevel}
                  isError={!!this.state.validateErr.careerLevelErr}
                />
              </InputContainer>
            </div>
            <div className="row">
              <InputContainer>
                <Label htmlFor="career_sub_level" isRequired>
                  Career Sub Level
                </Label>
                <SelectDropdown
                  options={FilteredCareerSubLevel}
                  onChange={this.handleSelectorChange.bind(
                    this,
                    "career_sub_level"
                  )}
                  value={selectedCareerSubLevel}
                  isError={!!this.state.validateErr.careerSubLevelErr}
                />
              </InputContainer>
              <InputContainer>
                <Label htmlFor="basic_salary" isRequired>
                  Basic Salary
                </Label>
                <SalaryInput
                  value={basic_salary}
                  onChange={this.handleInputChange}
                  isError={!!this.state.validateErr.basicSalaryErr}
                />
              </InputContainer>
            </div>
            <AddButton onClick={this.handleAdd} />

            <div
              className="row margin-y"
              style={{
                marginTop: "40px",
              }}
            >
              <table
                width="99%"
                className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive rm-marginTop"
                id="dataTables"
              ></table>
            </div>

            <RemarkInput value={remark} onChange={this.handleInputChange} />
            <SubmitButton
              onClick={this.handleSave}
              isDisabled={salarySlips.length <= 0}
            />
          </form>
        </div>
      </div>
    );
  }
}
